import MicroModal from 'micromodal'

interface Equipment {
  ID: number,
  post_title: string,
  content: string
  image: string,
  side_view: string,
  rear_view: string
}

const equipmentModalID = 'equipment-modal'
const equipmentModal = document.getElementById( equipmentModalID )
const equipmentOverlay = equipmentModal?.querySelector( '.modal__overlay' )
const equipmentCloseBtn = equipmentModal?.querySelector( '[data-modal-close]' )

/**
 * Get equipment for a quote based on the industry selected
 * @param industryId Post ID of the industry to get equipment for
 */
function getQuoteEquipment( industryId: number ) {

  // Define the base URL for your local REST API endpoint
  const baseApiUrl = '/wp-json/api/v1/quote-equipment/'

  // Construct the full URL with the industry ID
  const requestUrl = `${baseApiUrl}${industryId}`

  // Display loading spinner
  document.getElementById( 'industry-select-container' )?.classList.add( 'loading' )

  // Use the fetch API to make the GET request
  fetch( requestUrl )
    .then( response => {

      // Scroll to the top of the page
      window.scrollTo( 0, 0 )

      // Remove the loading bar after 1 second
      setTimeout( () => {
        document.getElementById( 'industry-select-container' )?.classList.remove( 'loading' )
      }, 1000 )

      // Check if the request was successful
      if ( !response.ok ) {
        throw new Error( `HTTP error! status: ${response.status}` )
      }
      return response.json()
    } )
    .then( data => {
      displayEquipmentImages( data?.data )
      adjustWidth()
    } )
    .catch( error => {
      // Handle any errors that occurred during the fetch
      console.error( 'There was a problem with the fetch operation:', error )
    } )

}

window.addEventListener( 'resize', () => {
  adjustWidth()
}, { passive: true } )

const adjustWidth = () => {
  // console.warn( 'adjust width' )
  const container = document.querySelector<HTMLDivElement>( '.slides' )
  if ( container ) container.scrollLeft = 0
  const equipmentItems = document.querySelector<HTMLElement>( '.equipment-items' )
  const allEquipmentItems = document.querySelectorAll<HTMLElement>( '.equipment-items div' )
  let length = allEquipmentItems.length
  if ( length < window.innerWidth ) {
    length = window.innerWidth
  }
  const trees = document.querySelector<HTMLElement>( '.slide-trees' )
  const mountains = document.querySelector<HTMLElement>( '.slide-mountains' )
  // translateZ(-100px) translateX(-200px) translateY(200px)
  // console.log( equipmentItems, equipmentItems.clientWidth )
  // trees.style.width = `${equipmentItems.clientWidth}px`
  if ( equipmentItems && mountains && trees ) {
    let equipmentWidth = equipmentItems.offsetWidth
    // console.log( 'equipmentItems.clientWidth', equipmentItems.offsetWidth )
    // console.log( 'compensation', 100 * length )
    // const width = equipmentItems.offsetWidth + ( 200 * length )
    // const width2 = equipmentItems.offsetWidth + ( 1250 * length )
    if ( equipmentWidth < window.innerWidth ) {
      equipmentWidth = window.innerWidth
    }
    const width = equipmentWidth
    const width2 = equipmentWidth
    mountains.style.width = `${width}px`
    trees.style.width = `${width2}px`
    // mountains.style.transform = 'translateZ(-400px) translateX(-20%) translateY(0) scale(1.1)'
    // scale next
    // trees.style.transform = 'translateZ(-10px)'
    // trees.style.transform = 'translateZ(-200px) translateX(-10%) translateY(0)'
    // scale next
  }
}

/**
* Display equipment images: This function populates a DOM element with images of equipment.
* It takes an array of equipment objects, creates a div for each, and appends a button and image to it.
* The button opens a modal with equipment details when clicked.
* The function also adjusts the backdrop elements' dimensions based on the total width of the equipment items.
* @param equipmentArray Array of equipment objects
*/
function displayEquipmentImages( equipmentArray: any ) {

  // Find the container where the images will be displayed
  const trucksContainer = document.getElementById( 'trucks' )

  if ( !trucksContainer ) {
      console.error( 'Could not find the trucks container element' )
      return
  }

  // Clear out any existing content
  trucksContainer.querySelectorAll( '.equipment-item' ).forEach( item => item.remove() )

  // Loop over each equipment item in the array
  equipmentArray.forEach( ( equipment: Equipment ) => {

    // Create a div to wrap the button and the image
    const wrapperDiv = document.createElement( 'div' )
    wrapperDiv.classList.add( 'equipment-item' )
    // Add data attribute with a normalized title of the equipment
    wrapperDiv.dataset.title = equipment.post_title.toLowerCase().replace( ' ', '-' )

    // Create a button element
    const button = document.createElement( 'button' )
    button.textContent = equipment.post_title
    button.style.cursor = 'pointer'
    // Add data attribute with the ID of the equipment
    button.dataset.id = equipment.ID.toString()

    // Add click event listener to the button
    button.addEventListener( 'click', () => showEquipmentModal( equipment ) )

    // Create an img element for the question mark
    const questionMark = document.createElement( 'img' )
    questionMark.src = '/wp-content/themes/AdenLogistics/assets/images/question-mark.svg'
    questionMark.alt = ''
    questionMark.classList.add( 'question-mark' )
    button.appendChild( questionMark )

    // Create an img element
    const img = document.createElement( 'img' )
    img.src = equipment.image
    img.alt = equipment.post_title
    img.classList.add( 'equipment-image', 'mr-4' )

    // Append the button and the img to the wrapper div
    wrapperDiv.appendChild( button )
    wrapperDiv.appendChild( img )

    // Append the wrapper div to the container
    trucksContainer.querySelector( '.equipment-items' ).appendChild( wrapperDiv )

    // const equipmentItems = document.querySelector<HTMLElement>( '.equipment-items' )
    // const trees = document.querySelector<HTMLElement>( '.slide-trees' )
    // const mountains = document.querySelector<HTMLElement>( '.slide-mountains' )
    // // translateZ(-100px) translateX(-200px) translateY(200px)
    // // console.log( equipmentItems, equipmentItems.clientWidth )
    // // trees.style.width = `${equipmentItems.clientWidth}px`
    // if ( equipmentItems && mountains && trees ) {
    //   console.log( 'equipmentItems.clientWidth', equipmentItems.clientWidth )
    //   const width = equipmentItems.clientWidth + 800
    //   // const width2 = equipmentItems.clientWidth + 400
    //   mountains.style.width = `${width}px`
    //   // trees.style.width = `${width2}px`
    //   mountains.style.transform = 'translateZ(-400px) translateX(-500px) translateY(-100px) scale(1.1)'
    //   trees.style.transform = 'translateZ(-200px) translateX(-300px) translateY(0px) scale(0.4)'
    // }

  } )

  // Calculate the width of all equipment-items
  const equipmentItems = document.querySelectorAll( '.equipment-item' )
  const margin = 100
  const equipmentItemWidth = ( ( 350 + margin ) * equipmentItems.length ) + 250

  console.log( 'equipmentItemWidth', equipmentItemWidth )

  const mountainsBackdrop = document.querySelector( '#mountains .backdrop' ) as HTMLDivElement
  const mountainsBackgroundImage = mountainsBackdrop?.style.backgroundImage
  mountainsBackdrop?.setAttribute( 'style', `background-image: ${mountainsBackgroundImage}; width: ${equipmentItemWidth}px; height: ${equipmentItemWidth}px` )

  const treesBackdrop = document.querySelector( '#trees .backdrop' ) as HTMLDivElement
  const treesBackgroundImage = treesBackdrop?.style.backgroundImage
  treesBackdrop?.setAttribute( 'style', `background-image: ${treesBackgroundImage}; width: ${equipmentItemWidth}px; height: ${equipmentItemWidth}px` )

  setTimeout( () => {

    const rotatedDiv = document.getElementById( 'trucks' )
    if ( rotatedDiv ) {
      rotatedDiv.style.overflowY = ''
      rotatedDiv.scrollTo( { top: 0, left: 0, behavior: 'smooth' } )
    }

    setTimeout( () => {
      manageTrucksScrolling()
    }, 250 )

  } , 250 )

}

/**
* Click listener for each view button in the modal
*/
equipmentModal?.querySelectorAll( '.view-buttons button' ).forEach( viewButton => {
  console.log( 'view button clicked' )
  const btn: HTMLElement = viewButton as HTMLElement
  btn.addEventListener( 'click', ( e: Event ) => {
      e.preventDefault()
      e.stopPropagation()
      const image = btn.dataset.image
      const alt = btn.dataset.alt
      const modalImage = equipmentModal.querySelector( '.image-container' )
      if ( modalImage === null ) {
          console.error( 'Could not find the modal image container' )
          return
      }
      // If the button does now have an image, add a `no-image` class to the modal image container
      if ( !image || image === 'false' ) {
        console.log( 'no image' )
        equipmentModal?.classList.add( 'no-image' )
          return
      } else {
        equipmentModal?.classList.remove( 'no-image' )
        modalImage.innerHTML = `<img src="${image}" alt="${alt}">`
      }
  } )
} )

// /**
// * Event listener to close the modal
// */
// equipmentModal?.querySelectorAll( '.modal__close' ).forEach( closeButton => {
//   closeButton.addEventListener( 'click', () => {
//       // Remove 'overflow-hidden' class to the body to allow scrolling
//       document.body.classList.remove( 'overflow-hidden' )
//       MicroModal?.close( 'equipment-modal' )
//   } )
// } )

// /**
// * Event listener to close the modal when clicking outside
// */
// equipmentModal?.addEventListener( 'click', ( event ) => {
//   if ( event.target === document.querySelector( '.modal__overlay' ) ) {
//       MicroModal?.close( 'equipment-modal' )
//       // Remove 'overflow-hidden' class to the body to allow scrolling
//       document.body.classList.remove( 'overflow-hidden' )
//   }
// } )

/**
 * Redefine the deltaY event as writable and reset it
 * if the wheel event is not 0.
 *
 * @param event The wheel event.
 */
const handleResetVerticalScroll = ( event: WheelEvent ) => {
    if ( event.deltaY !== 0 )
      Object.defineProperty( event, 'deltaY', { value: 0, writable: true } )
}

/**
* Disable scrolling when the last item is visible and scrolling down,
* and re-enable it when scrolling up.
*/
function manageTrucksScrolling() {
  const trucksDiv = document.getElementById( 'trucks' ) as HTMLDivElement

  trucksDiv.removeEventListener( 'wheel' , () => {
    console.log( 'removed' )
  } )
  trucksDiv.addEventListener( 'wheel', function( event ) {
    const lastItem = this.lastElementChild as HTMLElement

    handleResetVerticalScroll( event )

    // Get the bounding client rect of the last item and the trucks div
    const lastItemRect = lastItem.getBoundingClientRect()
    const trucksDivRect = trucksDiv.getBoundingClientRect()

    // Check if the last item is fully visible within the viewport
    // Considering the rotation, we use 'right' instead of 'bottom'
    const lastItemVisible = lastItemRect.right <= trucksDivRect.right &&
                            lastItemRect.left >= trucksDivRect.left

    if ( lastItemVisible ) {

      // If we are using a touch device
      // if ( 'ontouchstart' in window || 'ontouchmove' in window ) {
      //   // If we are scrolling down
      //   if ( event.deltaX > 0 ) {
      //     // Prevent the default behavior
      //     event.preventDefault()
      //     // Disable scrolling
      //     this.style.overflowY = 'hidden'
      //   } else {
      //     // Enable scrolling
      //     this.style.overflowY = ''
      //   }
      // } else {

      //   // Console log if we are scrolling up or down on the Y axis
      //   if ( event.deltaY > 0 ) {
      //     console.log( 'scrolling down' )
      //     this.style.overflowY = 'hidden'
      //   } else {
      //     console.log( 'scrolling up' )
      //     this.style.overflowY = ''
      //   }

      // }

    }

  }, false )
}

/**
 * Hide both 'side view' and 'rear view' buttons.
 */
const hideBothViewButtons = () => {
  const viewButtons = document.querySelector<HTMLDivElement>( '.view-buttons' )
  if ( viewButtons ) viewButtons.style.display = 'none'
}

/**
 * Show the equipment modal
 * @param equipment Equipment object
 */
const showEquipmentModal = ( equipment: Equipment ) => {

    // Scroll to the top of the page
    window.scrollTo( 0, 0 )

    const modalTitle = document.getElementById( 'equipment-modal-title' )
    const modalContent = document.getElementById( 'equipment-modal-content' )
    if ( modalTitle === null || modalContent === null ) {
      console.error( 'Could not find the modal elements' )
      return
    }
    // Update the modal content with the title and description
    modalTitle.textContent = equipment.post_title
    modalContent.innerHTML = equipment.content

    // Update button data attributes "data-image" and "data-alt" with the image URL and alt text in the .view-buttons container
    const sideViewButton = document.querySelector<HTMLButtonElement>( '#equipment-view-side' )
    const rearViewButton = document.querySelector<HTMLButtonElement>( '#equipment-view-rear' )
    if ( sideViewButton === null || rearViewButton === null ) {
      console.error( 'Could not find the view buttons' )
      return
    }

    if ( equipment.side_view ) {
      sideViewButton.dataset.image = equipment.side_view
      sideViewButton.dataset.alt = equipment.post_title
    } else {
      sideViewButton.disabled = true
    }

    if ( equipment.rear_view ) {
      rearViewButton.dataset.image = equipment.rear_view
      rearViewButton.dataset.alt = equipment.post_title
    } else {
      hideBothViewButtons()
      rearViewButton.disabled = true
    }

    sideViewButton.click()
    equipmentModal?.focus()

    // Cleanup previous modal state
    equipmentModal?.classList.remove( 'display-content' )

    // Open the modal using MicroModal
    MicroModal.show( equipmentModalID )

    // Disable vertical scrolling on body with overflow y hidden tailwind class
    document.body.classList.add( 'overflow-hidden' )

    setTimeout( () => {
      equipmentModal?.classList.add( 'display-content' )
      // Focus on the modal__container
      equipmentModal?.focus()

    }, 250 )

}

/**
 * Close the help modal with the given id
 * @param {string} id
 */
const closeEquipmentModal = ( id: string ) => {

  const modal = document.getElementById( id )
  modal?.classList.remove( 'display-content' )

  // Enable vertical scrolling on body removing overflow y hidden tailwind class
  document.body.classList.remove( 'overflow-hidden' )

  setTimeout( () => {
    MicroModal.close( id )
  }, 250 )
}

// Attach close event listener to the overlay, and the button with the [data-modal-close] attribute
const equipmentCloseElements = Array.from( document.querySelectorAll( '[data-modal-close]' ) )
const handleEquipmentCloseClick = ( event: Event ) => {
  if ( equipmentCloseElements.includes( event.target as HTMLElement ) )
    closeEquipmentModal( equipmentModalID )
}

equipmentCloseElements.forEach( ( element ) => {
  element?.removeEventListener( 'click', ( event: Event ) => handleEquipmentCloseClick( event ) )
  element?.addEventListener( 'click', ( event: Event ) => handleEquipmentCloseClick( event ) )
} )

export { adjustWidth }
export default getQuoteEquipment